import moment from "moment";
export const auditColumns = [
  {
    name: "Date",
    cell: (row) =>  moment(row["datetime"]).format("DD-MM-YYYY hh:mm:ss A"),
  },
  { name: "User", cell: (row) => row["username"] },
  { name: "Interface", cell: (row) => row["interfaceType"]["name"] },
  { name: "Action", cell: (row) => row["serviceResponse"] },
];